import { render, staticRenderFns } from "./FooterIndex.vue?vue&type=template&id=69e2f092&scoped=true"
import script from "./FooterIndex.vue?vue&type=script&lang=js"
export * from "./FooterIndex.vue?vue&type=script&lang=js"
import style0 from "./FooterIndex.vue?vue&type=style&index=0&id=69e2f092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e2f092",
  null
  
)

export default component.exports